export default __webpack_public_path__ + "static/index-header-img-md-ru-3ef3a991fa97de90165a447db49840dc.webp";